<template>
  <div class="platform">
    <div class="article">
      <img
        v-if="$i18n.locale === 'en'"
        src="../assets/freefooter-en.png"
        class="freefooter"
      />
      <img
        v-if="$i18n.locale === 'cn'"
        src="../assets/freefooter-cn.png"
        class="freefooter"
      />
      <img
        v-if="$i18n.locale === 'TW'"
        src="../assets/freefooter-tw.png"
        class="freefooter"
      />
      <ul class="platform-list">
        <li class="pc">
          <p class="name">{{ $t('title1') }}</p>
          <p class="desc">{{ $t('desc1') }}</p>
        </li>
        <li class="phone">
          <p class="name">{{ $t('title2') }}</p>
          <p class="desc">{{ $t('desc2') }}</p>
        </li>
        <li class="ipad">
          <p class="name">{{ $t('title3') }}</p>
          <p class="desc">{{ $t('desc3') }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
}
</script>
<style lang="scss" scoped>
.freefooter {
  width: 900px;
  height: auto;
}
.platform {
  text-align: center;
  padding: 80px 0;
  background: #fff;
}
.platform-list {
  margin-top: 80px;
  margin-right: -20px;
  text-align: center;
  overflow: hidden;
  li {
    float: left;
    width: 386px;
    margin-right: 20px;
    height: 220px;
    padding-top: 20px;
    border-left: 1px solid #e2e2e2;
    &:first-child {
      border-left: 0;
    }
    &:before {
      content: '';
      display: block;
      height: 95px;
      margin-bottom: 10px;
      background: url(../assets/pc.png) no-repeat center center;
    }
    &.phone:before {
      background-image: url(../assets/phone2.png);
    }
    &.ipad:before {
      background-image: url(../assets/ipad.png);
    }
  }
  .name {
    font-size: 18px;
    line-height: 24px;
  }
  .desc {
    color: #999;
    margin-top: 10px;
  }
}
</style>
<style scoped>
@media screen and (max-width: 768px) {
  .freefooter {
    width: 100%;
  }
  .platform-list {
    width: 100%;
    margin: 0;
  }
  .platform {
    padding: 0;
  }
  .platform-list li {
    width: 100%;
    /* margin: 0; */
    padding: 0 20px;
  }
}
</style>
<i18n>
{
  "cn": {
    "title1": "电脑客户端上课平台",
    "desc1": "屏幕更大 体验更好",
    "title2": "手机APP端预约平台",
    "desc2": "随时随地 方便快捷",
    "title3": "iPad 预约及上课平台",
    "desc3": "一个设备两种功能。随处可用，方便快捷。"
  },
  "TW": {
    "title1": "電腦用戶端上課平臺",
    "desc1": "荧幕更大 體驗更好",
    "title2": "手機APP端預約平臺",
    "desc2": "隨時隨地 方便快捷",
    "title3": "iPad 預約及上課平臺",
    "desc3": "一個設備兩種功能。隨處可用，方便快捷。"
  },
  "en": {
    "title1": "Use a desktop/laptop computer for lessons. ",
    "desc1": "Bigger screen, better experience. ",
    "title2": "Mobile app booking.",
    "desc2": "Fast and convenient. Anytime, anywhere.",
    "title3": "Use an iPad for both booking and lessons.",
    "desc3": "One device for both uses. Mobile and convenient. "
  }
}
</i18n>
